document.addEventListener("DOMContentLoaded", () => {
  const contentList = document.querySelector(".solstice__articles-content ul");
  const items = Array.from(contentList.querySelectorAll("li"));
  items
    .sort((a, b) => Number(b.dataset.date) - Number(a.dataset.date))
    .forEach((item) => contentList.appendChild(item));

  const filterList = document
    .querySelector(".solstice__articles-filter")
    .querySelectorAll("li");
  const articlesList = contentList.querySelectorAll("li");
  let activeFilter = document.querySelector(".is-active");

  filterList.forEach((filter) => {
    filter.addEventListener("click", () => {
      hideAllArticles();
      filter.classList.add("is-active");
      activeFilter.classList.remove("is-active");
      activeFilter = filter;

      if (filter.dataset.blogHandle === "all-articles") {
        articlesList.forEach((article) => article.classList.add("visible"));
        return;
      }
      showArticlesByBlogHandle(filter.dataset.blogHandle);
    });
  });

  function hideAllArticles() {
    articlesList.forEach((article) => article.classList.remove("visible"));
  }

  function showArticlesByBlogHandle(blogHandle) {
    articlesList.forEach((article) => {
      if (article.dataset.blogHandle === blogHandle) {
        article.classList.add("visible");
      }
    });
  }
});
